module.exports = __webpack_public_path__ + "img/calculator-fill.68c82f3a.svg";